
import {mapGetters} from 'vuex'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'

import {authShake} from '@/api/user'

export default {
name: 'app',
components: {
Tabbar,
TabbarItem,
XHeader,
ViewBox
},
computed: {
...mapGetters([
'title'
])
},
data () {
return {
tabBarIdx: 0,
orderTab: '',
sysInfo: {}
}
},
methods: {
goBack () {
this.$router.go(-1)
},
changeTabBarIdx () {
if (this.$route.name === 'index') {
this.tabBarIdx = 0
} else if (this.$route.name === 'mediaIndex') {
this.tabBarIdx = 1
} else if (this.$route.name === 'cart') {
this.tabBarIdx = 2
} else if (this.$route.name === 'order') {
this.tabBarIdx = 3
} else if (this.$route.name === 'me') {
this.tabBarIdx = 4
}
}
},
created () {
setInterval(function () {
authShake().then(resp => {})
}, 30000)
this.changeTabBarIdx()
},
updated () {
this.changeTabBarIdx()
}
}



// WEBPACK FOOTER //
// ./src/App.vue